/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as actionTypes from './AddressBookEntry-ActionTypes';

export const loadAddressBookEntry = (pageNumber, handleCallback) => ({
    type: actionTypes.LOAD_ADDRESS_BOOK_ENTRY,
    data: {
        pageNumber,
        handleCallback,
    },
});

export const loadBillingAddressBookEntry = () => ({
    type: actionTypes.LOAD_BILLING_ADDRESS_BOOK_ENTRY,
});

export const setAddressBookEntry = (addressBookEntries, totalEntries, pageNumber, totalPages) => ({
    type: actionTypes.SET_ADDRESS_BOOK_ENTRY_LIST,
    data: {
        addressBookEntries,
        totalEntries,
        pageNumber,
        totalPages,
    },
});

export const clearAddressBookEntry = () => ({
    type: actionTypes.CLEAR_ADDRESS_BOOK_ENTRY,
});

export const savedAddressBookEntry = () => ({
    type: actionTypes.SAVED_ADDRESS_BOOK_ENTRY,
});

export const proccessAddressBookEntryCompleted = () => ({
    type: actionTypes.PROCESS_ADDRESS_BOOK_ENTRY_COMPLETED,
});

export const addAddressBookEntry = (addressBookEntry) => ({
    type: actionTypes.ADD_ADDRESS_BOOK_ENTRY,
    data: {
        addressBookEntry,
    },
});

export const editAddressBookEntry = (addressBookEntry) => ({
    type: actionTypes.EDIT_ADDRESS_BOOK_ENTRY,
    data: {
        addressBookEntry,
    },
});

export const removeAddressBookEntry = (addressBookEntryId) => ({
    type: actionTypes.REMOVE_ADDRESS_BOOK_ENTRY,
    data: {
        addressBookEntryId,
    },
});

export const setBillingUserAddressBookEntry = (data) => ({
    type: actionTypes.SET_BILLING_USER_ADDRESS_BOOK_ENTRY,
    data,
});
